import {
  HierarchyFilterItemMapOption,
  HierarchyFilterItemOption,
  HierarchyFilterOptionsMap,
} from "../types";

export const getOptionLabel = (value: string, isProjectRootFilter: boolean): string => {
  return isProjectRootFilter && !value ? "(empty, defaults to repo root)" : value;
};

export const checkLabelFilter = (filterName: string) => filterName === "label";
export const projectRootFilter = (filterName: string) => filterName === "projectRoot";

export const makeHierarchyOptions = (
  options: HierarchyFilterItemOption[],
  searchInput: string
): [HierarchyFilterOptionsMap, HierarchyFilterItemMapOption[]] => {
  // Create initial map with children arrays
  const optionsMap: HierarchyFilterOptionsMap = new Map(
    options.map((item) => [item.id, { ...item, children: [] }])
  );

  // Build parent-child relationships
  options.forEach((item) => {
    if (item.parentId) {
      const parentItem = optionsMap.get(item.parentId);
      if (parentItem) {
        parentItem.children.push(item.id);
      }
    }
  });

  // Create new map with calculated counts
  const calculatedOptionsMap: HierarchyFilterOptionsMap = new Map();

  optionsMap.forEach((item, itemId) => {
    calculatedOptionsMap.set(itemId, item);
  });

  const firstLevelOptions =
    searchInput.length > 0
      ? [...calculatedOptionsMap.values()]
      : [...calculatedOptionsMap.values()].filter((item) => !item.parentId);

  return [calculatedOptionsMap, firstLevelOptions];
};
